export const handleSubmit = ({ updateContract, history, currentCustomerId, contractId }) => values => {

  if (!!values.tiiviiOttConfig && !values.tiiviiOttConfig.enabled) {
    values.tiiviiOttConfig.webhookUrl = '';
    values.tiiviiOttConfig.nimbleConfigUrl = '';
  }

  const updatedData = updateContract({
    variables: {
      contractInput: values,
      customerId: currentCustomerId,
      contractId,
    },
  });

  return updatedData.then(result => {
    const contract = result.data.updateContract;
    if (contract) {
      history.goBack();
    }
  });
};
